import { Observable } from 'rxjs';

export abstract class AbstractDataSourceModel {
    abstract search(args: any): Observable<any>;
    abstract all(): Observable<any>;
}
